window.refreshCompareTabs = function () {
    const container = document.querySelector(".sticky");
    if (!container) return;

    const activeBtn = container.querySelector(".tab-button.active");
    const underline = container.querySelector(".tab-underline");

    if (!activeBtn || !underline) return;

    const rect = activeBtn.getBoundingClientRect();
    const tabsRect = activeBtn.parentElement.getBoundingClientRect();

    underline.style.width = rect.width + "px";
    underline.style.transform = `translateX(${rect.left - tabsRect.left}px)`;
};

document.addEventListener("DOMContentLoaded", function () {
    const popup = document.querySelector('#buy-section-popup');
    const overlay = document.querySelector('#buy-section-popup-overlay');
    const close = document.querySelector('#buy-section-popup-close');
    const wrapper = document.querySelector('.buy-popup-wrapper');
    const openButtons = document.querySelectorAll('.popup-button');

    if (!popup || !overlay || !wrapper) return;

    function isMobile() {
        return window.matchMedia("(max-width: 767px)").matches;
    }

    function getPopupTransformInit() {
        return isMobile()
            ? "translate(0%, 100%)"
            : "translate(0%, 0%) scale(0.8)";
    }

    function getPopupTransformFinal() {
        return isMobile()
            ? "translate(0%, 0%)"
            : "translate(0%, 0%) scale(1)";
    }

    // INIT STATE
    gsap.set(popup, {
        transform: getPopupTransformInit(),
        opacity: 0,
        visibility: "hidden"
    });

    function showPopup() {
        wrapper.style.display = "flex";
        overlay.classList.add("show");
        popup.classList.add("show");

        gsap.to(popup, {
            duration: 0.6,
            opacity: 1,
            visibility: "visible",
            transform: getPopupTransformFinal(),
            ease: "power2.out",
            onComplete: () => {
                if (window.refreshCompareTabs) {
                    window.refreshCompareTabs();
                }
                if (typeof window.refreshCompareColumns === "function") {
                    window.refreshCompareColumns();
                }
                document.dispatchEvent(new CustomEvent("buy-section-popup:opened"));
            }
        });
    }

    function closePopup() {
        overlay.classList.remove("show");
        popup.classList.remove("show");

        gsap.to(popup, {
            duration: 0.4,
            opacity: 0,
            visibility: "hidden",
            transform: getPopupTransformInit(),
            ease: "power2.inOut",
            onComplete: () => {
                wrapper.style.display = "none";
            }
        });
    }

    // OPEN
    openButtons.forEach(btn => {
        btn.addEventListener("click", (e) => {
            e.preventDefault();
            showPopup();
        });
    });

    // CLOSE
    if (close) close.addEventListener("click", closePopup);
    overlay.addEventListener("click", closePopup);

    // RESIZE FIX
    window.addEventListener("resize", () => {
        if (popup.classList.contains('show')) {
            gsap.set(popup, {
                transform: getPopupTransformFinal()
            });
        }
    });
});

// ----------------------------------------------------------
// TABS SECTION (beze změn)
// ----------------------------------------------------------

document.addEventListener("DOMContentLoaded", () => {
    const container = document.querySelector(".sticky");
    if (!container) return;

    const buttons = container.querySelectorAll(".tab-button");
    const contents = container.querySelectorAll(".tab-content");
    const underline = container.querySelector(".tab-underline");

    if (!buttons.length || !underline) return;

    function moveUnderline(target) {
        const rect = target.getBoundingClientRect();
        const tabsRect = target.parentElement.getBoundingClientRect();
        underline.style.width = rect.width + "px";
        underline.style.transform = `translateX(${rect.left - tabsRect.left}px)`;
    }

    function activateTab(tabName, push = true) {
        buttons.forEach(btn =>
            btn.classList.toggle("active", btn.dataset.tab === tabName)
        );
        contents.forEach(content =>
            content.classList.toggle("active", content.id === tabName)
        );

        const activeButton = container.querySelector(`.tab-button[data-tab="${tabName}"]`);
        if (activeButton) moveUnderline(activeButton);

        if (push) {
            const url = new URL(window.location);
            url.searchParams.set("tab", tabName);
            window.history.replaceState({}, "", url);
        }
    }

    // Inicializace
    const params = new URLSearchParams(window.location.search);
    const defaultTab = params.get("tab") || (buttons[0]?.dataset.tab || null);

    if (defaultTab) {
        activateTab(defaultTab, false);

        // prodleva pro underline
        setTimeout(() => {
            const activeBtn = container.querySelector(".tab-button.active");
            if (activeBtn) moveUnderline(activeBtn);
        }, 100);
    }

    buttons.forEach(btn => {
        btn.addEventListener("click", () => activateTab(btn.dataset.tab));
    });

    window.addEventListener("resize", () => {
        const activeBtn = container.querySelector(".tab-button.active");
        if (activeBtn) moveUnderline(activeBtn);
    });
});
